import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const EmptyWebhook = ({ setIsEnableCreate }) => {
  const theme = useTheme();

  return (
    <>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.grey[600],
          fontSize: '22px'
        }}
      >
        Aún no has configurado tu WEBHOOK
      </Typography>
      <Stack>
        <Button variant="outlined" onClick={() => setIsEnableCreate(true)}>
          Configurar Webhook
        </Button>
      </Stack>
    </>
  );
};

EmptyWebhook.propTypes = { setIsEnableCreate: PropTypes.func };

export default EmptyWebhook;
